module.exports = __webpack_public_path__ + "static/media/clipboard.fc7f5c84.svg";